import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import '../../../assets/css/components/Shared/ToggleDropDown/toggle-drop-down.css'

type ToggleDropDownProp = {
	open: boolean
	setOpen: () => void
}

export const ToggleDropDown: React.FC<ToggleDropDownProp> = ({
	open,
	setOpen
}: ToggleDropDownProp) => {
	return (
		<button
			className='ToggleDropDown'
			type='button'
			onClick={() => {
				setOpen()
			}}>
			<FontAwesomeIcon icon={open ? faMinus : faPlus} />
		</button>
	)
}
